function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { _InputCheckboxStyled, _InputCheckboxLabel } from "../style";
import { _InputWrapperDiv } from "../../input/inputStyles";
import InputLabel from "../../input/InputLabel";
import ErrorContainer from "../../input/ErrorContainer";
var InputMultiCheckbox = function InputMultiCheckbox(_ref) {
  var defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    error = _ref.error,
    input = _ref.input,
    labelText = _ref.labelText,
    onChange = _ref.onChange,
    options = _ref.options,
    required = _ref.required;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(InputLabel, {
    labelText: labelText,
    required: required
  })), options && options.map(function (option, index) {
    var _React$createElement;
    return /*#__PURE__*/React.createElement(_InputCheckboxStyled, {
      key: index,
      display: "inline-flex"
    }, /*#__PURE__*/React.createElement("input", (_React$createElement = {
      name: "".concat(name, "[").concat(index, "]"),
      value: option.value,
      checked: input.value.indexOf(option.value) !== -1,
      defaultChecked: defaultChecked
    }, _defineProperty(_React$createElement, "name", option.value), _defineProperty(_React$createElement, "onChange", onChange), _defineProperty(_React$createElement, "type", "checkbox"), _defineProperty(_React$createElement, "disabled", disabled), _React$createElement)), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement(_InputCheckboxLabel, null, option.label));
  }), /*#__PURE__*/React.createElement(ErrorContainer, {
    error: error
  }));
};
InputMultiCheckbox.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.string,
  name: PropTypes.string,
  obj: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  required: PropTypes.bool,
  state: PropTypes.object,
  visible: PropTypes.bool
};
export default InputMultiCheckbox;